import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Photo from 'components/common/Photo/Photo';
import { useTrackViewCheckIn } from 'hooks/useTrackView';
import { trackInteraction } from 'services/analytics';

const CheckInPhoto = (props) => {
  const { id, photo, setPhoto, isSending, photoRequired, deviceId, registrationId } = props;

  const [isCameraDisabled, setCameraDisabled] = useState(false);

  useTrackViewCheckIn('photo', id, deviceId, registrationId);

  const commonDetails = {
    registration_id: registrationId,
    location_id: id,
    device_id: deviceId,
    is_guest_pre_checked: false,
  };

  const skipPhoto = () => {
    const objectDetails = {
      ...commonDetails,
      object_identifier: 'skip',
      camera_access: isCameraDisabled ? 'disabled' : 'enabled',
    };
    trackInteraction('photo', objectDetails);

    setPhoto({ src: null, takenAt: null, submitted: false, skipped: true });
  };

  const submitPhoto = () => {
    const objectDetails = {
      ...commonDetails,
      object_identifier: 'next',
    };
    trackInteraction('photo', objectDetails, 'capture_picture', 'take_photo');

    setPhoto({ ...photo, submitted: true });
  };

  const trackTakePhoto = () => {
    const objectDetails = {
      ...commonDetails,
      object_identifier: 'takePhoto',
    };
    trackInteraction('photo', objectDetails);
  };

  const trackRetake = () => {
    const objectDetails = {
      ...commonDetails,
      object_identifier: 'retake',
    };
    trackInteraction('photo', objectDetails, 'capture_picture', 'take_photo');
  };

  const variables = {
    photo,
    setPhoto,
    isSending,
    photoRequired,
    registrationType: 'check-in',
    skipPhoto,
    submitPhoto,
    setCameraDisabled,
    trackTakePhoto,
    trackRetake,
  };

  return <Photo {...variables} />;
};

CheckInPhoto.propTypes = {
  id: PropTypes.string,
  photo: PropTypes.shape({
    src: PropTypes.string,
  }),
  setPhoto: PropTypes.func,
  isSending: PropTypes.bool,
  photoRequired: PropTypes.bool,
  deviceId: PropTypes.string,
  registrationId: PropTypes.string,
};

export default CheckInPhoto;
